/**
 * TASK-19 · Registers the hand-written service worker (public/service-worker.js).
 *
 * Only registers in production builds — a SW in dev caches stale assets and
 * fights hot-reload. Test the PWA/install flow against `npm run build`.
 */
function register() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker.register(swUrl).catch((error) => {
      // Non-fatal: the app still works online without the SW.
      // eslint-disable-next-line no-console
      console.error("Service worker registration failed:", error);
    });
  });
}

function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}

export { register, unregister };
